<template>
  <div v-loading="loading">
    <div class="table relative" v-if="groupby === 'employee'">
      <el-table
        v-if="!reports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Log Attendance Reports available."
      >
      </el-table>
      <el-table
        v-else
        v-for="report of reports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report ? report.days : []"
        width="100%"
        v-loading="loading"
        empty-text="No Log Attendance Reports available."
        class="colored-head"
      >
        <el-table-column :label="getHeader(report)">
          <el-table-column sortable prop="checkdate" label="DATE" align="left">
            <template slot-scope="scope">
              <div>
                {{ scope.row.checkdate ? scope.row.checkdate : "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="serial_no" label="Serial No" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.serial_no }}
              </div>
            </template>
          </el-table-column>

          <el-table-column sortable prop="device_name" label="Device Name">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.device_name !== null ? scope.row.device_name : "NA"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="clocktype"
            label="Clock Type"
          ></el-table-column>
          <el-table-column sortable prop="clocktime" label="Clock Time">
            <template slot-scope="scope">
              <div>
                {{ scope.row.clocktime !== null ? scope.row.clocktime : "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="upload_time"
            label="Upload Time"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>

    <div class="table" v-else>
      <el-table
        v-if="!reports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Log Attendance Reports available."
      >
      </el-table>
      <el-table
        v-else
        v-for="report of reports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report.employees"
        width="100%"
        v-loading="loading"
        empty-text="No Log Attendance Reports available."
        class="colored-head"
      >
        <el-table-column :label="getDateHeader(report.date)">
          <el-table-column prop="employee_details" label="Name" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="employee_details" label="Pin" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.pin }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            sortable
            prop="clocktime"
            label="Time"
          ></el-table-column>
          <el-table-column
            sortable
            prop="clocktype"
            label="Clock Type"
          ></el-table-column>
          <el-table-column sortable prop="device_name" label="Device Name">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.device_name !== null ? scope.row.device_name : "NA"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="serial_no"
            label="Serial No"
          ></el-table-column>
          <el-table-column
            sortable
            prop="upload_time"
            label="Upload Time"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reports", "groupby", "loading"],

  methods: {
    getDateHeader(date) {
      return `Attendance Log Report for ${date}`;
    },

    getHeader(report) {
      return `Employee Name:    ${report.employee_details.name} - Pin: ${
        report.employee_details.pin
      }`;
    },
  },
};
</script>
